import { ColDef } from "ag-grid-community";

export const fillerColDef: ColDef[] = [
  {
    field: "filler",
    colId: "filler",
    lockPosition: "right",
    headerName: " ",
    headerClass: "noRightBorder",
    flex: 1,
    hide: false,
    suppressColumnsToolPanel: true,
    suppressHeaderFilterButton: true,
    suppressHeaderMenuButton: true,
    filter: false,
    resizable: false,
    sortable: false,
    lockVisible: true,
    enableRowGroup: false,
    mainMenuItems: ["resetColumns"],
  },
];
